"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactVis = require("react-vis");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _chartUtils = require("../../chartUtils");

var _colors = require("../../constants/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RangeSlider = /*#__PURE__*/function (_AbstractSeries) {
  _inherits(RangeSlider, _AbstractSeries);

  var _super = _createSuper(RangeSlider);

  function RangeSlider(props) {
    var _this;

    _classCallCheck(this, RangeSlider);

    _this = _super.call(this, props);

    _this.getNewResizedEnd = function (direction, newPoint, max) {
      if (direction === 'right') {
        return newPoint <= max ? newPoint : max;
      }

      return newPoint >= 25 ? newPoint : 25;
    };

    _this.handleResize = function (e, direction) {
      var _getXY = (0, _chartUtils.getXY)(e.nativeEvent || e),
          x = _getXY.x;

      var _this$props = _this.props,
          maxDate = _this$props.maxDate,
          minControlWidth = _this$props.minControlWidth,
          minDate = _this$props.minDate,
          onResize = _this$props.onResize;
      var _this$state = _this.state,
          startX = _this$state.startX,
          startArea = _this$state.startArea,
          isResizing = _this$state.isResizing;

      var _this$convertCoordina = _this.convertCoordinatesToArea({
        start: minDate,
        end: maxDate
      }),
          right = _this$convertCoordina.right;

      if (isResizing) {
        var delta = x - startX;

        var newArea = _objectSpread(_objectSpread({}, startArea), {}, _defineProperty({}, direction, _this.getNewResizedEnd(direction, startArea[direction] + delta, right)));

        if (newArea.right - newArea.left > minControlWidth) {
          _this.setState({
            nextArea: newArea
          });

          if (onResize) {
            onResize(_this.convertAreaToCoordinates(newArea));
          }
        }
      }
    };

    var start = props.start,
        end = props.end;

    var _startArea = _this.convertCoordinatesToArea({
      start: start,
      end: end
    });

    _this.state = {
      cursor: 'pointer',
      dragging: false,
      isResizing: false,
      nextArea: _startArea,
      resizeDirection: null,
      startArea: _startArea,
      startX: 0
    };
    _this.handleWidth = 20;
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RangeSlider, [{
    key: "getNextArea",
    value: function getNextArea(x) {
      var _this$state2 = this.state,
          startX = _this$state2.startX,
          startArea = _this$state2.startArea;
      return {
        left: startArea.left + (x - startX),
        right: startArea.right + (x - startX)
      };
    }
  }, {
    key: "convertCoordinatesToArea",
    value: function convertCoordinatesToArea(coordinates) {
      var xScale = _reactVis.ScaleUtils.getAttributeScale(this.props, 'x');

      var marginLeft = this.props.marginLeft;
      return {
        left: xScale(coordinates.start) + marginLeft,
        right: xScale(coordinates.end) + marginLeft
      };
    }
  }, {
    key: "convertAreaToCoordinates",
    value: function convertAreaToCoordinates(area) {
      var marginLeft = this.props.marginLeft;

      var xScale = _reactVis.ScaleUtils.getAttributeScale(this.props, 'x'); // Ensure that users wishes are being respected about which scales are evaluated
      // this is specifically enabled to ensure brushing on mixed categorical and linear
      // charts will run as expected


      return {
        left: xScale.invert(area.left - marginLeft),
        right: xScale.invert(area.right - marginLeft)
      };
    }
  }, {
    key: "convertPositionToCoordinate",
    value: function convertPositionToCoordinate(position) {
      var marginLeft = this.props.marginLeft;

      var xScale = _reactVis.ScaleUtils.getAttributeScale(this.props, 'x');

      return xScale.invert(position - marginLeft);
    }
  }, {
    key: "isWithinLeftHandle",
    value: function isWithinLeftHandle(e) {
      var _getXY2 = (0, _chartUtils.getXY)(e.nativeEvent),
          x = _getXY2.x;

      var areaLeftPx = this.state.nextArea.left;
      var overlayLeftPx = this.getOverlayLeftPx();
      return x > overlayLeftPx && x < areaLeftPx;
    }
  }, {
    key: "isWithinRightHandle",
    value: function isWithinRightHandle(e) {
      var _getXY3 = (0, _chartUtils.getXY)(e.nativeEvent),
          x = _getXY3.x;

      var areaRightPx = this.state.nextArea.right;
      var overlayRightPx = this.getOverlayRightPx();
      return x > areaRightPx && x < overlayRightPx;
    }
  }, {
    key: "isCursorOverDragControl",
    value: function isCursorOverDragControl(e) {
      var _getXY4 = (0, _chartUtils.getXY)(e.nativeEvent),
          x = _getXY4.x;

      var _this$state$nextArea = this.state.nextArea,
          left = _this$state$nextArea.left,
          right = _this$state$nextArea.right;
      return x > left && x < right;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      var isLeftHandle = this.isWithinLeftHandle(e);
      var isRightHandle = this.isWithinRightHandle(e);
      var isDragControl = this.isCursorOverDragControl(e);

      if (isLeftHandle) {
        this.startResizing(e, 'left');
      } else if (isRightHandle) {
        this.startResizing(e, 'right');
      } else if (isDragControl) {
        this.startDragging(e);
      }
    }
  }, {
    key: "startDragging",
    value: function startDragging(e) {
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
      var onDragStart = this.props.onDragStart;

      var _getXY5 = (0, _chartUtils.getXY)(e.nativeEvent),
          x = _getXY5.x,
          y = _getXY5.y;

      this.setState({
        cursor: 'grabbing',
        dragging: true,
        isResizing: false,
        resizeDirection: null,
        startX: x,
        startLocY: y
      });

      if (onDragStart) {
        onDragStart(e);
      }
    }
  }, {
    key: "startResizing",
    value: function startResizing(e, resizeDirection) {
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);

      var _getXY6 = (0, _chartUtils.getXY)(e.nativeEvent),
          x = _getXY6.x,
          y = _getXY6.y;

      this.setState({
        dragging: false,
        isResizing: true,
        resizeDirection: resizeDirection,
        startX: x,
        startLocY: y
      });
    }
  }, {
    key: "handleCursor",
    value: function handleCursor(e) {
      var changeHoverValue = this.props.changeHoverValue;
      var isLeftHandle = this.isWithinLeftHandle(e);
      var isRightHandle = this.isWithinRightHandle(e);

      if (isLeftHandle || isRightHandle) {
        changeHoverValue();
        this.setState({
          cursor: 'ew-resize'
        });
      } else if (this.isCursorOverDragControl(e)) {
        changeHoverValue();
        this.setState({
          cursor: 'grab'
        });
      } else {
        var _getXY7 = (0, _chartUtils.getXY)(e.nativeEvent),
            x = _getXY7.x;

        changeHoverValue(this.convertPositionToCoordinate(x));
        this.setState({
          cursor: 'pointer'
        });
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      var _this$state3 = this.state,
          isResizing = _this$state3.isResizing,
          resizeDirection = _this$state3.resizeDirection,
          dragging = _this$state3.dragging;

      if (!dragging && !isResizing) {
        this.handleCursor(e);
      }

      if (dragging) {
        var _getXY8 = (0, _chartUtils.getXY)(e.nativeEvent || e),
            x = _getXY8.x;

        this.handleDragging(x);
      }

      if (isResizing) {
        this.handleResize(e, resizeDirection);
      }
    }
  }, {
    key: "handleDragging",
    value: function handleDragging(x) {
      var _this$props2 = this.props,
          maxDate = _this$props2.maxDate,
          minDate = _this$props2.minDate;

      var _this$convertCoordina2 = this.convertCoordinatesToArea({
        start: minDate,
        end: maxDate
      }),
          right = _this$convertCoordina2.right;

      var nextArea = this.getNextArea(x);

      if (nextArea.left >= 25 && nextArea.right <= right) {
        this.setState({
          nextArea: nextArea
        });
      }

      var areaSize = nextArea.right - nextArea.left;

      if (nextArea.left < 25) {
        this.setState({
          nextArea: {
            left: 25,
            right: 25 + areaSize
          }
        });
      }

      if (nextArea.right > right) {
        this.setState({
          nextArea: {
            left: right - areaSize,
            right: right
          }
        });
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var _this$state4 = this.state,
          dragging = _this$state4.dragging,
          isResizing = _this$state4.isResizing;
      if (dragging || isResizing) return;
      this.handleMouseUp();
    }
  }, {
    key: "handleDateClick",
    value: function handleDateClick(x) {
      var _this$props3 = this.props,
          maxDate = _this$props3.maxDate,
          minDate = _this$props3.minDate,
          onClickDate = _this$props3.onClickDate;
      var nextArea = this.state.nextArea;

      var _this$convertCoordina3 = this.convertCoordinatesToArea({
        start: minDate,
        end: maxDate
      }),
          left = _this$convertCoordina3.left,
          right = _this$convertCoordina3.right;

      var rangeFromMiddle = (nextArea.right - nextArea.left) / 2;

      if (x - rangeFromMiddle < left) {
        onClickDate(this.convertAreaToCoordinates({
          left: left,
          right: left + rangeFromMiddle * 2
        }));
      } else if (x + rangeFromMiddle > right) {
        onClickDate(this.convertAreaToCoordinates({
          right: right,
          left: right - rangeFromMiddle * 2
        }));
      } else {
        onClickDate(this.convertAreaToCoordinates({
          right: x + rangeFromMiddle,
          left: x - rangeFromMiddle
        }));
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(e) {
      var _this$state5 = this.state,
          isResizing = _this$state5.isResizing,
          dragging = _this$state5.dragging,
          nextArea = _this$state5.nextArea;
      var _this$props4 = this.props,
          changeHoverValue = _this$props4.changeHoverValue,
          onResizeEnd = _this$props4.onResizeEnd,
          onDragEnd = _this$props4.onDragEnd;

      if (!isResizing && !dragging) {
        if (e) {
          var _getXY9 = (0, _chartUtils.getXY)(e.nativeEvent),
              x = _getXY9.x;

          this.handleDateClick(x);
          return;
        }

        changeHoverValue();
        return;
      }

      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
      this.setState({
        isResizing: false,
        resizeDirection: null,
        dragging: false,
        nextArea: nextArea,
        startX: 0,
        startArea: nextArea
      });

      if (isResizing && onResizeEnd) {
        onResizeEnd(this.convertAreaToCoordinates(nextArea));
      }

      if (!isResizing && onDragEnd) {
        onDragEnd(this.convertAreaToCoordinates(nextArea));
      }
    }
  }, {
    key: "getPlotWidth",
    value: function getPlotWidth() {
      var _this$props5 = this.props,
          innerWidth = _this$props5.innerWidth,
          marginLeft = _this$props5.marginLeft,
          marginRight = _this$props5.marginRight;
      return marginLeft + marginRight + innerWidth;
    }
  }, {
    key: "getOverlayLeftPx",
    value: function getOverlayLeftPx() {
      var areaLeftPx = this.state.nextArea.left;
      return Math.max(areaLeftPx - this.handleWidth, 0);
    }
  }, {
    key: "getOverlayWidthPx",
    value: function getOverlayWidthPx() {
      var areaRightPx = this.state.nextArea.right;
      var plotWidth = this.getPlotWidth();
      var overlayLeftPx = this.getOverlayLeftPx();
      return Math.min(Math.max(0, areaRightPx - overlayLeftPx + this.handleWidth), plotWidth);
    }
  }, {
    key: "getOverlayRightPx",
    value: function getOverlayRightPx() {
      return this.getOverlayLeftPx() + this.getOverlayWidthPx();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          className = _this$props6.className,
          fill = _this$props6.fill,
          innerHeight = _this$props6.innerHeight,
          marginBottom = _this$props6.marginBottom,
          marginTop = _this$props6.marginTop,
          opacity = _this$props6.opacity,
          stroke = _this$props6.stroke;
      var _this$state6 = this.state,
          cursor = _this$state6.cursor,
          _this$state6$nextArea = _this$state6.nextArea,
          areaLeftPx = _this$state6$nextArea.left,
          areaRightPx = _this$state6$nextArea.right;
      var plotWidth = this.getPlotWidth();
      var plotHeight = marginTop + marginBottom + innerHeight;
      var overlayLeftPx = this.getOverlayLeftPx();
      var overlayWidthPx = Math.min(Math.max(0, areaRightPx - overlayLeftPx + this.handleWidth), plotWidth);
      var handleLeftX = overlayLeftPx;
      var handleRightX = areaRightPx;
      return /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(0,0)",
        className: "".concat(className, " rv-range-slider-container")
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        transform: "translate(".concat(areaLeftPx, ", 0)"),
        className: "rv-slider-control-center",
        opacity: opacity,
        fill: fill,
        stroke: stroke,
        width: overlayWidthPx - 40,
        height: plotHeight
      }), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(".concat(handleLeftX, ", 0)")
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "20",
        height: "101",
        viewBox: "0 0 20 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "10",
        y: "0",
        width: "10",
        height: "100",
        fill: _colors.NAVY
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M11 60V40L0 50L10 60Z",
        fill: _colors.NAVY
      }))), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(".concat(handleRightX, ", 0)")
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "20",
        height: "101",
        viewBox: "0 0 20 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "10",
        height: "100",
        fill: _colors.NAVY
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M9 40L10 60L20 50L10 40Z",
        fill: _colors.NAVY
      }))), /*#__PURE__*/_react["default"].createElement("rect", {
        className: "rv-mouse-target",
        cursor: cursor,
        fill: "black",
        height: Math.max(plotHeight, 0),
        onMouseDown: function onMouseDown(e) {
          return _this2.handleMouseDown(e);
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.handleMouseLeave();
        },
        onMouseMove: function onMouseMove(e) {
          return _this2.handleMouseMove(e);
        },
        onMouseUp: function onMouseUp(e) {
          return _this2.handleMouseUp(e);
        },
        opacity: "0",
        stroke: _colors.NAVY,
        width: Math.max(plotWidth, 0),
        x: "0",
        y: "0"
      }));
    }
  }]);

  return RangeSlider;
}(_reactVis.AbstractSeries);

RangeSlider.displayName = 'RangeSlider';
RangeSlider.defaultProps = {
  className: '',
  fill: 'rgb(255, 255, 255)',
  minControlWidth: 1,
  onClickDate: undefined,
  onDragEnd: undefined,
  onResize: undefined,
  onResizeEnd: undefined,
  opacity: '0.8',
  stroke: _colors.NAVY
};
RangeSlider.propTypes = _objectSpread(_objectSpread({}, _reactVis.AbstractSeries.propTypes), {}, {
  fill: _propTypes["default"].string,
  minControlWidth: _propTypes["default"].number,
  onClickDate: _propTypes["default"].func,
  onDragEnd: _propTypes["default"].func,
  onResize: _propTypes["default"].func,
  onResizeEnd: _propTypes["default"].func,
  opacity: _propTypes["default"].string,
  stroke: _propTypes["default"].string
});
var _default = RangeSlider;
exports["default"] = _default;